import { TEMPLATES_ROUTES } from '../../constants/_routes'
import templatesTypes from '../../constants/templatesTypes'
import { axios } from '../../services'

// INDEX
const templates_xlsx_request = () => {
  return {
    type: templatesTypes.xlsx.request
  }
}

const templates_xlsx_success = () => {
  return {
    type: templatesTypes.xlsx.success
  }
}

const templates_xlsx_failure = (messages) => {
  return {
    type: templatesTypes.xlsx.failure,
    payload: messages
  }
}

const templates_xlsx = (filters={}, sort="", order="", variant="") => {
  return function (dispatch) {
    // Before Request
    dispatch(templates_xlsx_request())
    document.body.classList.add('instalevel-fetching-data')

    axios.get(
      `${TEMPLATES_ROUTES.index}.xlsx`,
      {
        params: {
          sort: sort,
          order: order,
          filters: filters,
          variant: variant
        },
        responseType: 'blob'
      }
    ).then( response => {
      // success
      const blob = URL.createObjectURL(response.data, "mitsos")
      const filename = (variant !== "") ? `templates_${variant}.xlsx` : 'templates.xlsx'
      let fileLink = document.createElement('a')
      document.body.appendChild(fileLink);
      fileLink.style="display: none"
      fileLink.href = blob
      fileLink.download = filename
      fileLink.click();
      URL.revokeObjectURL(blob)
      dispatch( templates_xlsx_success() )
      document.body.classList.remove('instalevel-fetching-data')
    }).catch( error=> {
      // failure
      document.body.classList.remove('instalevel-fetching-data')
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching xlsx file."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( templates_xlsx_failure(errors))
    })
  }
}

export {
  templates_xlsx
}



// WEBPACK FOOTER //
// ./src/js/actions/templates/getxlsx.js